module.exports = __webpack_public_path__ + "static/media/quality1.3ca5a304.webp";